<template>
    <v-row>
        <v-col class="col-5 d-flex justify-center flex-column">
            <div class="title">{{ title }}</div>
            <div v-if="description" class="grey--text body-2">{{ description }}</div>
            <a v-if="downloadLink" :href="downloadLink" class="body-2" target="_blank">{{ downloadText }}</a>
        </v-col>
        <v-col class="col-7 text-right d-flex justify-center flex-column">
            <slot></slot>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "DetailViewHeader",
    props: {
        title: {
            type: String,
            default: "Placeholder Title"
        },
        description: {
            type: String,
            default: ""
        },
        downloadLink: {
            type: String,
            default: null
        },
        downloadText: {
            type: String,
            default: null
        }
    },
    data() {
        return {};
    }
};
</script>
